import { useState } from "react";
import { usePageTranslation } from "@/i18n/useTranslation";
import { useLanguage } from "@/i18n/useLanguage";
import { supportTranslations as enSupport } from "@/i18n/locales/en/support";
import { supportTranslations as thSupport } from "@/i18n/locales/th/support";
import { WidgetTicketList } from "./WidgetTicketList";
import { WidgetTicketView } from "./WidgetTicketView";
import { WidgetCompose } from "./WidgetCompose";

type Mode = "list" | "ticket" | "new";

/**
 * The support mini-app body: list → ticket thread → new request. Header/close
 * are provided by the host (the right app-rail panel). Self-contained nav state.
 */
export function SupportPanelBody({ onClose }: { onClose: () => void }) {
  const { language } = useLanguage();
  const t = usePageTranslation({ en: enSupport, th: thSupport }) as typeof enSupport;
  const [mode, setMode] = useState<Mode>("list");
  const [activeTicket, setActiveTicket] = useState<string | null>(null);

  const openTicket = (id: string) => {
    setActiveTicket(id);
    setMode("ticket");
  };

  if (mode === "ticket" && activeTicket) {
    return (
      <WidgetTicketView
        ticketNo={activeTicket}
        onBack={() => {
          setMode("list");
          setActiveTicket(null);
        }}
        t={t}
        language={language}
      />
    );
  }
  if (mode === "new") {
    return <WidgetCompose onBack={() => setMode("list")} onCreated={openTicket} t={t} />;
  }
  return (
    <WidgetTicketList
      onOpenTicket={openTicket}
      onNew={() => setMode("new")}
      onClose={onClose}
      t={t}
      language={language}
    />
  );
}
